import type { EventProperties } from "@flare/analytics";
import { analytics } from "@flare/analytics";

import { BiEventsNames } from "@/services/analytics/bi-event-names";
import { getData, setData } from "@/services/storage/session-storage";

export function trackWebVitals(
  analyticsDataStorageKey: string,
  metric: EventProperties,
) {
  const storedMetrics = getData(analyticsDataStorageKey) || {};

  if (!storedMetrics[metric.name]) {
    storedMetrics[metric.name] = metric;
    setData(analyticsDataStorageKey, storedMetrics);
    analytics.track(BiEventsNames.WebVitals, metric);
  }
}
